import { Entity } from 'src/app/modules/portfolio/models/entity';
import { EntityResponseAuditable } from '../../../../web-api-client';

export const mapEntityFromResponse = (
  response: EntityResponseAuditable
): Entity => ({
  entityId: response.entityId,
  clientId: response.client?.clientId,
  clientName: response.client?.name,
  residencyJurisdictionId: response.residencyJurisdictionId,
  entityTypeId: response.entityTypeId,
  name: response.name,
  description: response.description ?? '',
  isActive: response.isActive ?? false,
});
